import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/en.json";
import trTranslations from "./locales/tr.json";
import deTranslations from "./locales/de.json";
import frTranslations from "./locales/fr.json";
import esTranslations from "./locales/es.json";

import { applyTenantOverride, defaultOverrideLoader } from "./loadTenantOverride";
import { getCurrentTenant } from "../config/tenantConfig";

const baseResources = {
  en: { translation: enTranslations },
  tr: { translation: trTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
  es: { translation: esTranslations },
};

const tenant = getCurrentTenant();
const resources = applyTenantOverride(
  baseResources,
  tenant.localeOverride,
  defaultOverrideLoader
);

const isRcu = tenant.projectCode === "RCU";

// Decide the initial language. A language counts as "chosen" ONLY when the user
// explicitly picks one — via the ?lng= querystring, or the language switcher
// which sets the "langSelected" flag. The cached i18nextLng alone does NOT count
// as a choice (the detector writes it automatically from the browser locale).
// When nothing has been chosen, RCU starts in English instead of the TR fallback.
function resolveInitialLng() {
  try {
    const qs = new URLSearchParams(window.location.search).get("lng");
    if (qs) return qs;
    if (localStorage.getItem("langSelected") === "1") {
      return localStorage.getItem("i18nextLng") || undefined;
    }
  } catch (e) {
    // localStorage / URL not available — fall through to defaults
  }
  return isRcu ? "en" : undefined;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: resolveInitialLng(),
    fallbackLng: isRcu ? "en" : "tr",
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupLocalStorage: "i18nextLng",
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },
  });

export default i18n;
